import Swiper from 'swiper'
import $ from 'jquery'

export default {
  init() {
    $( ".stepsSlider-slider" ).each(function( index ) {
      const s = new Swiper($(this)[0], {
        slidesPerView: IS_MOBILE ? 1 : 'auto',
        spaceBetween: 20,
      })

      $(this).find('.stepsSlider-nav-item--next').on('click', () => {
        s.slideNext()
      })

      $(this).find('.stepsSlider-nav-item--prev').on('click', () => {
        s.slidePrev()
      })
    })
  }
};
